<template>
  <el-dialog
    :visible.sync="isFormDialogVisible"
    custom-class="course-dialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="handleClickClose"
    :append-to-body="true"
    top="0px"
  >
    <div
      slot="title"
      class="dialog-header"
    >
      <span>{{ presentDate }}</span>
      <h2>{{ data.id ? data.parent_course.name : "수업 개설" }}</h2>
    </div>

    <el-tabs
      v-model="dialogTab"
      class="dialog-tab"
      :before-leave="beforeTabLeave"
    >
      <el-tab-pane
        label="기본 정보"
        :name="COURSE_DIALOG_TAB.COURSE_INFO"
      >
        <ChildCourseEditForm
          :key="data.id"
          :is-past="isPast"
          :is-open="isFormDialogVisible"
          :data="data"
          :has-booking="hasBooking"
          @changeDate="onChangeDate"
          @update="onChildCourseUpdate"
          @closeDialog="handleClickClose"
        />
      </el-tab-pane>

      <el-tab-pane
        v-if="isBookingSystem"
        label="예약"
        :name="COURSE_DIALOG_TAB.BOOKING"
      >
        <booking-form
          v-if="data.id"
          ref="bookingForm"
          :child-course="data"
          @update="onBookingUpdate"
          @sync="onBookingDataSync"
        />
      </el-tab-pane>

      <el-tab-pane
        label="히스토리"
        :name="COURSE_DIALOG_TAB.BOOKING_HISTORY"
      >
        <booking-history
          v-if="data.id"
          ref="bookingHistory"
          :child-course="data"
        />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ChildCourseEditForm from './course-dialog/ChildCourseEditForm';
import koLocale from 'date-fns/locale/ko';
import dateFns from 'date-fns';
import BookingForm from './course-dialog/BookingForm';
import BookingHistory from './course-dialog/BookingHistory';
import { TIME_UNIT, COURSE_DIALOG_TAB } from '../../constants';

export default {
  name: 'ChildCourseFormDialog',
  components: {
    BookingHistory,
    BookingForm,
    ChildCourseEditForm
  },
  props: ['tab'],
  data() {
    return {
      COURSE_DIALOG_TAB,
      isFormDialogVisible: false,
      dialogTab: COURSE_DIALOG_TAB.COURSE_INFO,
      hasBooking: false,
      date: null,
      data: {
        start: new Date(),
        dt: new Date(),
        id: null,
        parent_course: null,
        duration: TIME_UNIT.HOUR,
        price: 0,
        quota: 1,
        recurrence: null,
        to_single: false,
        is_offline: true,
        from_date: null,
        is_support_wait_booking: false
      }
    };
  },
  watch: {
    isFormDialogVisible(isVisible) {
      if (isVisible) {
        window.addEventListener('focus', this.handleReloadBookingAndHistories);
      } else {
        window.removeEventListener(
          'focus',
          this.handleReloadBookingAndHistories
        );
      }
    }
  },
  computed: {
    presentDate() {
      return dateFns.format(this.date, 'YYYY년 M월 D일 dddd HH:mm', {
        locale: koLocale
      });
    },
    isPast() {
      return dateFns.differenceInMinutes(this.date, new Date()) < -1;
    },
    isBookingSystem() {
      return this.$store.getters.getIsBookingSystem;
    }
  },
  methods: {
    onBookingDataSync(bookings) {
      this.hasBooking = bookings.length > 0;
    },
    onChangeDate(date) {
      this.date = date;
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (this.data.id) {
        return true;
      }

      if (oldActiveName === 'course-info') {
        this.$alert(
          '현재 작성 중인 내용을 먼저 완료해주세요.',
          '작성 중인 내용이 있습니다.',
          {
            confirmButtonText: '확인',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray',
            cancelButtonClass: 'white'
          }
        );

        return false;
      }
    },
    async handleClickClose() {
      this.isFormDialogVisible = false;
      this.clearCourseData();
    },
    onChildCourseUpdate() {
      this.$emit('update');
    },
    onBookingUpdate() {
      this.$refs['bookingHistory'].syncBookingHistoryData();
      this.$emit('update');
      this.$store.dispatch('syncVaildMembers');
    },
    clearCourseData() {
      this.data = {
        start: new Date(),
        dt: new Date(),
        id: null,
        parent_course: null,
        instructors: [],
        duration: TIME_UNIT.HOUR,
        price: 0,
        quota: 1,
        to_single: false,
        is_offline: true,
        is_support_wait_booking: false
      };
    },
    openDialogToAdd(dt, tab = null) {
      this.clearCourseData();
      if (dt) {
        this.data.dt = dt;
      }

      this.date = this.data.dt;
      this.dialogTab = tab || COURSE_DIALOG_TAB.COURSE_INFO;
      this.isFormDialogVisible = true;
    },
    openDialogToModify(data, tab = null) {
      if (tab === COURSE_DIALOG_TAB.BOOKING && !this.isBookingSystem) {
        tab = COURSE_DIALOG_TAB.BOOKING_HISTORY;
      }

      this.dialogTab =
        tab ||
        (this.isBookingSystem
          ? COURSE_DIALOG_TAB.BOOKING
          : COURSE_DIALOG_TAB.BOOKING_HISTORY);
      this.clearCourseData();
      this.data = data;
      this.date = data.dt;
      this.isFormDialogVisible = true;
    },
    handleReloadBookingAndHistories() {
      this.$refs['bookingForm'].onBookedMemberUpdate();
      this.onBookingUpdate();
    }
  }
};
</script>

<style lang="scss">
.course-dialog {
  position: absolute;
  top: 24px;
  right: 24px;
  bottom: 24px;
  margin: 0;
  width: 555px;

  background: #f2f2f2;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  .el-dialog__header {
    flex: initial;
    padding: 30px;
    padding-bottom: 10px;

    .el-dialog__headerbtn {
      top: 30px;
      right: 30px;

      &:focus .el-dialog__close,
      &:hover .el-dialog__close {
        color: #4a4a4a;
      }
    }
  }

  .dialog-header {
    color: #4a4a4a;

    span {
      line-height: 19px;
      font-size: 13px;
      font-weight: 300;
      letter-spacing: -0.6px;
      margin-bottom: 5px;
    }

    h2 {
      margin: 5px 0 0 0;
      line-height: 24px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.5px;
    }
  }

  .el-dialog__body {
    flex: 1;
    padding: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    width: 100%;

    .el-tab-pane {
      width: 100%;
      flex: 1;
    }

    .dialog-tab {
      height: 100%;
      display: flex;
      flex-direction: column;
      margin: 0;
      flex: auto;
    }

    .el-tabs__header {
      flex: initial;
      padding: 10px 30px 0;
      margin: 0;

      .el-tabs__item {
        height: 32px;
        line-height: 22px;
        color: #9b9b9b;
      }

      .el-tabs__item.is-active {
        color: #4a4a4a;
      }
    }

    .el-tabs__content {
      width: 100%;
      flex: 100vh;
      overflow-y: auto;
      display: flex;
    }

    .el-form.el-form--label-top {
      padding: 20px 30px;
    }
  }

  @media screen and (max-width: 768px) {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    top: 10px;
    left: 10px;

    .el-dialog__header {
      padding: 20px;
      padding-bottom: 10px;

      .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
      }
    }

    .el-dialog__body {
      .el-tabs__header {
        padding: 10px 20px 0;
        margin: 0;

        .el-tabs__item {
          height: 32px;
          line-height: 22px;
        }
      }

      .el-form.el-form--label-top {
        padding: 20px 20px;
      }

      .dialog-tab {
        flex: 1;
      }
    }
  }
}
</style>
